import { LowerCasePipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { Award, AwardFeatureService, AwardsConfig } from '@rma/public/awards/public/api-awards';
import { minBy } from 'lodash-es';

@Component({
  selector: 'rma-market-report-top-award',
  templateUrl: './market-report-top-award.component.html',
  styleUrls: ['./market-report-top-award.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RmaIconComponent, LowerCasePipe, TitleCasePipe, TranslocoDirective],
})
export class MarketReportTopAwardComponent implements OnChanges {
  private readonly awardService = inject(AwardFeatureService);

  @Input()
  awards: Award[] | null | undefined;

  awardConfig?: AwardsConfig;
  award?: Award;

  ngOnChanges(changes: SimpleChanges): void {
    const { awards } = changes;

    if (awards) {
      this.award = this.getAward(this.awards);
      this.awardConfig = this.getAwardConfig(this.award?.awardType);
    }
  }

  private getAward(awards: Award[] | null | undefined): Award | undefined {
    return awards?.length ? minBy(awards, 'ranking') : undefined;
  }

  private getAwardConfig(awardType?: string): AwardsConfig | undefined {
    return awardType ? this.awardService.getAwardConfig(awardType) : undefined;
  }
}
